export default __webpack_public_path__ + "static/media/TCRE.20098c3b.webp";